import React from 'react';
import { SHOW_PARAMS } from "../../../../config";

const Row = ({ a, s, cc,  ...row }) => {
    const valuesTd = SHOW_PARAMS.map(param => <td key={param}>{row[param]}</td>);

    return (
        <tr>
            <td>{a}</td>
            <td>{s}</td>
            <td>{cc}</td>
            {valuesTd}
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PushapiExtended/components/Table/components/Row/index.js